import * as api from '../api/index'
import { ADD_NEW_ACCOUNT, UPDATE_ACCOUNT, DELETE_ACCOUNT, FETCH_ACCOUNTS_BY_USER, START_LOADING, END_LOADING } from './constants'

export const getAccountsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchAccountsByUser(searchQuery)
    dispatch({ type: FETCH_ACCOUNTS_BY_USER, payload: data })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response || error)
  }
}

export const createAccount = (account, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addAccount(account)
    dispatch({ type: ADD_NEW_ACCOUNT, payload: data })
    openSnackbar && openSnackbar('Account added successfully')
  } catch (error) {
    console.log(error)
  }
}

export const updateAccount = (id, account, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateAccount(id, account)
    dispatch({ type: UPDATE_ACCOUNT, payload: data })
    openSnackbar && openSnackbar('Account updated successfully')
  } catch (error) {
    console.log(error)
  }
}

export const deleteAccount = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteAccount(id)
    dispatch({ type: DELETE_ACCOUNT, payload: id })
    openSnackbar && openSnackbar('Account deleted successfully')
  } catch (error) {
    console.log(error)
  }
}
